export const mapRecipesToMagistralToMakePayload = (recipes) => {
  const productsList = recipes.flatMap((recipe) => {
    const toMakeProducts = recipe.products?.magistralToMake || [];

    return toMakeProducts.map((product) => ({
      recipe_id: recipe.id,
      product_type: "MAGISTRAL_TO_PREPARE",
      quantity: Number(product.quantity || 1),
      price: Number(product.price_unit || 0),
      discount: {
        type: "PERCENTAGE",
        value: Number(product.discount_percent || 0)
      },
      code_internal:uid(),
      laboratory: "Narma", 
      specifications: product.specifications || "",
      image_url: "https://storage.googleapis.com/tirx-resources-production/c12353e0-40ff-4f02-b00a-b58e3ddeff0e.png",
      pharmaceutical_form: product.form_pharmaceutical,
      form_quantity: Number(product.form_quantity), // Ojo: Aquí parece que usas quantity del producto como form_quantity? Revisa si tienes un campo específico.
      // En tu form tenías form_quantity separado de la cantidad de productos.
      // Si en el objeto product guardaste 'form_quantity' del formulario, úsalo aquí:
      // form_quantity: Number(product.form_quantity || 0),
      
      form_quantity_unit: product.form_unit, // En tu form se llama form_unit
      vehicle: product.vehicle,
      container_format: product.container_format,
      
      components: (product.components || []).map(comp => ({
        component_name: comp.component_name, // Ahora sí lo tenemos gracias al Paso A
        concentration_value: Number(comp.concentration_value || 0),
        concentration_unit: comp.concentration_unit
      }))
    }));
  });

  return { products: productsList };
};

function uid() {
  return Math.random().toString(36).slice(2, 9);
}